<template>
<section id="flex">
	<quote-navbar class="navbar-custom" v-bind:pageName='pageName'></quote-navbar>
	<div class="left-div" id="left">
		<div class="info-div" id="info">
			<b-button @click="showCollapse = !showCollapse"
                :class="showCollapse ? 'collapsed' : null"
                style="margin-bottom: 5px;"
                block
                variant="light"
                aria-controls="collapse"
                :aria-expanded="showCollapse ? 'true' : 'false'">
        <p v-if="showCollapse">Hide Customer Information<i class="fas fa-minus plus custom-icon"></i></p>
        <p v-else>Show Customer Information<i class="fas fa-plus plus custom-icon"></i></p>
      </b-button>
			<b-collapse v-model="showCollapse" id="collapse">
				<p>
					Customer Name: <strong>{{customerInfo.CustomerName}}</strong> <br>
					Customer Reference: <strong>{{customerInfo.CustomerReference}}</strong> <br>
					Customer Telephone: <strong>{{customerInfo.CustomerTel}}</strong> <br>
				</p>
				<p>	
					Customer Address: <strong>{{customerInfo.CustomerAddress}}</strong> <br>
					Customer Email: <strong>{{customerInfo.CustomerEmail}}</strong> <br>
				</p>
				<p>
					Site reference: <strong>{{siteRef}}</strong> <br>
					Quote Date: <strong>{{quoteDate}}</strong> <br>
					Expiry Date: <strong>{{expiryDate}}</strong> <br>
				</p>
		  <hr>
			</b-collapse>
		</div>
		<b-form-input v-model="siteRef"
									type="text"
									placeholder="Enter a site reference"></b-form-input>
    <div id="custom-add">
      <b-button @click="showAddCollapse = !showAddCollapse"
                :class="showCollapse ? 'collapsed' : null"
                style="margin-bottom: 5px;"
                block
                variant="light"
                aria-controls="collapse"
                :aria-expanded="showCollapse ? 'true' : 'false'">
        <p v-if="showAddCollapse">Hide Custom Add<i class="fas fa-minus plus custom-icon"></i></p>
        <p v-else>Show Custom Add<i class="fas fa-plus plus custom-icon"></i></p>
      </b-button>
			<b-collapse v-model="showAddCollapse" id="collapse">
				<p>Add a Custom Plant or Sundries</p>
        <b-form-input v-model="customPlantName"
									placeholder="Enter a plant name"
                  name="customPlantName"
									type="text"
									style="margin-top: 10px;"
									v-validate="'required'"></b-form-input>
                  <p class="text-danger" v-if="errors.has('customPlantName')">{{ errors.first('customPlantName') }}</p>
        <b-form-input v-model="customFormSize"
									placeholder="Enter a form size"
                  name="customFormSize"
									type="text"
									style="margin-top: 10px;"
									v-validate="'required'"></b-form-input>
                  <p class="text-danger" v-if="errors.has('customFormSize')">{{ errors.first('customFormSize') }}</p>
        <b-form-input v-model="customComment"
									placeholder="Enter a plant comment"
                  name="customComment"
									type="text"
									style="margin-top: 10px;"
									></b-form-input>  
									<p>Quantity</p>
        <b-form-input v-model="customQuantity"
									placeholder="Enter a quantity"
                  name="customQuantity"
									type="number"
									style="margin-top: 10px;"
									v-validate="'required|min_value:1'"></b-form-input> 
                  <p class="text-danger" v-if="errors.has('customQuantity')">{{ errors.first('customQuantity') }}</p>
				  <p>Price</p>
        <b-form-input v-model="customPrice"
									placeholder="Enter a price"
                  name="customPrice"
									type="number"
									style="margin-top: 10px;"
                  min="0"
                  step="1"
									v-validate="'required|decimal:2|min_value:0.01'"></b-form-input>                   
                  <p class="text-danger" v-if="errors.has('customPrice')">{{ errors.first('customPrice') }}</p>
				  <b-button @click="validateBeforeSubmit" variant="primary" style="margin-top: 5px;">Add Custom plant</b-button>
		  <hr>
			</b-collapse>
    </div>
		<!-- <label class="typo__label">Choose a plant to add to a quote</label>
		<multiselect v-model="selectedBatch" 
								:options="batches"  
								placeholder="Select a batch" 
								label="plantName"
								:loading="isLoading"
								:show-labels="false"
								:allow-empty="false"
								open-direction="bottom"
                @select="closeAddCollapse"
								>
			<template slot="option" slot-scope="props">
				<div>
					<span>{{props.option.plantName }} {{props.option.formSize }}</span>
					<br>
					<span> Quantity: {{props.option.quantity}} 
								<span v-if="!retail">Wholesale Price: <strong>£{{(props.option.batchPrice/100).toFixed(2)}}</strong></span>
								<span v-else>Retail Price: <strong>£{{((props.option.batchPrice/100)*1.5).toFixed(2)}}</strong></span>
					</span>
				</div>
			</template>
		</multiselect>
		<b-form-input v-model="quantity"
									placeholder="Enter a quantity"
									type="number"
                  pattern="[0-9]*"
									v-validate="'required|numeric|min_value:1'"
									name="quantity"
									inputmode="numeric"
									@keyup.enter.native="validateBeforeSubmit"
									@input="calculatePrice"></b-form-input>	
									<p class="text-danger" v-if="errors.has('quantity')">{{ errors.first('quantity') }}</p>
		
		<strong v-if="!retail">Calculated Price £{{calculatedPrice}}</strong>
		<strong v-else>Retail Price £{{calculatedPrice}}</strong>
		<br>							
	
		<strong v-if="!retail">Current discount: {{(currentGPM)}}%</strong>
		<br>
		
		<b-form-input v-model="comment"
									placeholder="Enter a plant comment"
									type="text"
									style="margin-top: 10px;"
									@keyup.enter.native="validateBeforeSubmit"></b-form-input>	
    <p v-if="showAddCollapse" style="color: red;"><b>Plants will be added from the Custom Add dropdown!</b></p>														
		<p v-else>Please add plants to the quote to save</p>			
		
		
		<br>
		<br> -->
		

		<b-button @click="openPlantPickerModal" variant="success" style="margin-top: 5px;">Search for plants to add to quote</b-button>		
<!-- <strong>Next Calculated Price £{{nextCalculatedPrice}}</strong>							 -->
	<!-- <strong>Qtn needed until next band {{untilNextBand}}</strong> -->
		<b-button @click="saveQuote" v-if="totalPrice != 0" variant="success" style="margin-top: 5px;"><p v-if="showCalculatePrice">Calculate Prices</p><p v-else>Save Quote</p></b-button>	
	</div>
		<div class="right-div" id="right">
			<strong style="font-size:18px; margin-right: 25px;">Quote Price: £{{computedTotalPrice}}</strong>
			<strong style="font-size:18px;">Total Quantity: {{totalQuantity}}</strong>  
			<!-- Quote Table -->
		  <b-table show-empty
								 stacked="md"
								 :items="plants"
								 :fields="fields"   
								 outlined>
      <div slot="empty">
        <strong>Add a plant to the quote</strong>
      </div>
      <template slot="Price" slot-scope="row">
        <b>£{{(row.item.Price/100).toFixed(2)}}</b>
      </template>
	  <template slot="PurchasingPrice" slot-scope="row">
        £{{(row.item.PurchasingPrice/100).toFixed(2)}}
      </template> 
	  <template slot="WholesalePrice" slot-scope="row">
       £{{(row.item.WholesalePrice/100).toFixed(2)}}
      </template> 
	   <template slot="OriginalPrice" slot-scope="row">
        £{{(row.item.OriginalPrice/100).toFixed(2)}}
      </template> 
			<template slot="actions" slot-scope="row">
				<b-button type="button" class="btn btn-success action-btn" @click.stop="editItem(row.item, row.index)"><i class="far fa-edit fa-lg" style="color:black"></i></b-button>
				<b-button type="button" class="btn btn-danger action-btn" @click="remove(row.index)"><i class="fas fa-trash-alt fa-lg" style="color:black"></i></b-button>
        <!-- Editing modal -->
        <b-modal :ref='"editModal"+row.index' no-close-on-backdrop hide-footer :title="rowName" @keyup.enter.native="validateEdits">
          <div>
            <b-form-group horizontal label="Comment:" >
              <b-form-input v-model="rowComment"
                            placeholder="Enter a comment" />
            </b-form-group>
            <b-form-group horizontal label="Quantity:" >
              <b-form-input v-model="rowQuantity"
                            placeholder="Enter a quantity"
                            type="number"
                            pattern="[0-9]*"
                            name="rowQuantity"
                            inputmode="numeric"
                            v-validate="'required|numeric|min_value:1'"/>
            </b-form-group>
            <p class="text-danger" v-if="errors.has('rowQuantity')">{{ errors.first('rowQuantity') }}</p>
            <b-form-group horizontal label="Price" >
              <b-form-input v-model="rowPrice"
                            placeholder="Enter a price"
                            inputmode="numeric"
                            name="rowPrice"
                            v-validate="'required|decimal:2|min_value:0.01'" />
            </b-form-group>
            <p class="text-danger" v-if="errors.has('rowPrice')">{{ errors.first('rowPrice') }}</p>
          </div>
            <b-button class="mt-3" id="btnSaveEdits" variant="primary" block @click.stop="validateEdits">Save Edits</b-button>
            <b-button class="mt-3" variant="danger" block @click="hideModal(row.index)">Close Me</b-button>
        </b-modal>
      </template>     
    </b-table>	
	</div>
	<!-- MODAL -->
    <b-modal v-model="showPlantPickerModal" size="xl" class="modal-xl" no-close-on-backdrop hide-footer title="Search and add a plant to a quote">
			
			<div v-if="showSearchTable">
				<div class="row">
				<div class="col-md-3 col-lg-3">
					<b-btn variant="primary" block @click="changeBatchSearchType">Change search</b-btn>
				</div>
				<div class="col-md-9 col-lg-9">
					<h4 v-if="searchLatestBatches">Searching latest upload</h4>
					<h4 v-else style="color:red;">Searching batches not on latest upload</h4>
				</div>
			</div>
					<div class="row">
						<div class="col-xs-12 col-md-12 col-lg-12">
							<b-input-group class="input-filter">
								<b-form-input type="text" v-model="plantSearch" placeholder="Type to Search" @keydown.native="searchForPlantEnter"/>
									<b-input-group-append>
										<b-btn variant="success" @click="searchForPlant">Search</b-btn>
									</b-input-group-append>
									<b-input-group-append>
										<b-btn variant="danger" @click="clearSearch">Clear</b-btn>
									</b-input-group-append>
							</b-input-group>
						</div>
					</div>
					<br>
					<div class="row">
						<div class="col-xs-4 col-md-4 col-lg-4">
							<multiselect 
							  v-model="selectedPlantNameFilter"
								:options="plantNameFilters"  
								placeholder="Select a plantname" 
								:loading="isLoading"
								:show-labels="false"
								:allow-empty="false"
								open-direction="bottom">
								</multiselect>
						</div>
						<div class="col-xs-2 col-md-2 col-lg-2">
							<!-- <multiselect 
								v-model="selectedFormSizeFilter"
								:options="formSizeFilters"  
								placeholder="Select a formsize" 
								:loading="isLoading"
								:show-labels="false"
								:allow-empty="false"
								open-direction="bottom">
								</multiselect> -->
							<input id="searchbar" type="text" v-model="selectedFormSizeFilter" placeholder="Select a formsize" >
						</div>
						<div class="col-xs-2 col-md-2 col-lg-2">
							<multiselect 
								v-model="selectedLocationFilter"
								:options="locationFilters"  
								placeholder="Select a location" 
								:loading="isLoading"
								:show-labels="false"
								:allow-empty="false"
								open-direction="bottom">
								</multiselect>
						</div>
						<div class="col-xs-1 col-md-1 col-lg-1">
							<b-btn variant="success" block @click="filterCurrentSearchedPlants()">Filter</b-btn>
						</div>
						<div class="col-xs-2 col-md-2 col-lg-2">
							<b-btn variant="success" block @click="removePBFromCurrentSearchedPlants()">Remove PB</b-btn>
						</div>
						<div class="col-xs-1 col-md-1 col-lg-1">
							<b-btn variant="danger" block @click="clearFilterCurrentSearchedPlants()">Clear</b-btn>
						</div>
					</div>
					
					<br>
					<div class="row">
						<div class="col-xs-12 col-md-12 col-lg-12">
							<b-table
							show-empty
							stacked="md"
							:items="currentSearchedPlants"
							:fields="searchedPlantFields"
							outlined
							>
							<template slot="actions" slot-scope="row">
								<!-- <b-input-group class="input-filter"> -->
									<!-- <b-form-input type="number" v-model="row.item.AmountToAddToPicklist" placeholder="Amount to add"/> -->
										<!-- <b-input-group-append> -->
											<b-btn variant="success" @click="showModalOtherScreen(row.item)">Add</b-btn>
										<!-- </b-input-group-append> -->
								<!-- </b-input-group> -->
							</template>
							<template slot="WholesalePrice" slot-scope="row">
								<b>£{{(row.item.WholesalePrice/100).toFixed(2)}}</b>
							</template>
							<template slot="PurchasingPrice" slot-scope="row">
								£{{(row.item.PurchasingPrice/100).toFixed(2)}}
							</template> 
						</b-table>
						</div>
					</div>
					<div class="row">
						<!-- Going to be for filtering shit -->
					</div>
			</div>
			<div v-if="showAddingPlantSection">
				<div class="row">
					<div class="col-xs-12 col-md-12 pull-left">
							<p>Plant Name: {{selectedRowFromSearch.PlantName}}</p>
					</div>
				</div>
				<div class="row">
					<div class="col-xs-4 col-md-4">
							<p>Available Quantity: {{selectedRowFromSearch.BatchQuantity}}</p>
					</div>
					<div class="col-xs-4 col-md-4">
							<p>Growing Quantity: {{selectedRowFromSearch.GrowingQuantity}}</p>
					</div>
						<div class="col-xs-4 col-md-4">
							<p>Allocated Quantity: {{selectedRowFromSearch.AllocatedQuantity}}</p>
					</div>
				</div>
				<div class="row">
					<div class="col-xs-12 col-md-12">
							<p>Location: {{selectedRowFromSearch.Location}}</p>
					</div>
				</div>
				<div class="row">
					<div class="col-xs-12 col-md-12">
							<p>FormSize: {{selectedRowFromSearch.FormSize}}</p>
					</div>
				</div>
				<div class="row">
					<div class="col-xs-12 col-md-12">
							<p>Wholesale Price: £{{(selectedRowFromSearch.WholesalePrice/100).toFixed(2)}}</p>
					</div>
				</div>
				<br>
				<div class="row">
					<div class="col-xs-6 col-md-6">
							<b-form-input v-model="quantity"
									placeholder="Enter a quantity"
									type="number"
                  pattern="[0-9]*"
									v-validate="'required|numeric|min_value:1'"
									name="quantity"
									inputmode="numeric"
									@input="calculatePriceNew">
							</b-form-input>	
					</div>
					<div class="col-xs-6 col-md-6">
						<strong v-if="!retail">Calculated Price £{{calculatedPrice}}</strong>
						<strong v-else>Retail Price £{{calculatedPrice}}</strong>
						<strong v-if="!retail">Current discount: {{(currentGPM)}}%</strong>
					</div>
				</div>
				<div class="row">
					<div class="col-xs-12 col-md-12">
						<b-form-input v-model="comment"
										placeholder="Enter a plant comment"
										type="text"
										style="margin-top: 10px;"
										@keyup.enter.native="validateBeforeSubmit">
						</b-form-input>	
					</div>
				</div>
				<div class="row" v-if="sellLessThanBuy">
					<div class="col-xs-12 col-md-12">
						<h4 style="color:red; margin-top: 10px;">Warning the selling price is less than or equal to the purchase price</h4>
					</div>
				</div>
				<br>
				
			</div>
        <div class="row" v-if="showAddingPlantSection">
          <div class="col-xs-3 col-md-3 col-lg-3">
            <b-button variant="danger" block @click="searchAgain()">Search Again</b-button>
            <!-- <b-button variant="danger" block >Close Modal</b-button> -->
          </div>
					<div class="col-xs-3 col-md-3 col-lg-3">
            <b-button variant="warning" block @click="backToLastSearch()">Last Search</b-button>
            <!-- <b-button variant="danger" block >Close Modal</b-button> -->
          </div>
					<div class="col-xs-3 col-md-3 col-lg-3">
            <b-button variant="success" block @click="addToList(true)">Add And Re-search</b-button>
            <!-- <b-button variant="danger" block >Close Modal</b-button> -->
          </div>
					<div class="col-xs-3 col-md-3 col-lg-3">
            <b-button variant="info" block @click="addToList(false)">Add And Keep Search</b-button>
            <!-- <b-button variant="danger" block >Close Modal</b-button> -->
          </div>
        </div>
    </b-modal>
	<!-- PDF Modal -- this will popup once the quote has been saved to the database -->
	<b-modal ref="createPDFModal" size="sm" title="Create a quote PDF?" centered hide-footer hide-header-close no-close-on-backdrop>
		<div class="modal__footer">
      <router-link to="/ExistingQuotes">
      	<b-button variant="danger">Back to quotes</b-button>
    	</router-link>
      <b-btn variant="primary" @click="createPDF">Create PDF</b-btn>
    </div>
  </b-modal>
</section>
</template>

<script>
import moment from 'moment'
import firebase from 'firebase/app';
import jsPDF from 'jspdf'
import 'jspdf-autotable';
import QuoteNavbar from '@/components/QuoteNavbar.vue'

export default {
	components: {
		QuoteNavbar,
	},
  data () {
		return {
			pageName: 'Quote Creation',
			plants: [],
			fields: [
				{ key: 'PlantName', label: 'Plant Name', sortable: true},
				{ key: 'FormSize', label: 'Form Size'},
				{ key: 'Comment', label: 'Comment'},
				{ key: 'Quantity', label: 'Quantity', sortable: true},
				{ key: "PurchasingPrice", label: "Purchasing Price"},
				{ key: "WholesalePrice", label: "Wholesale Price", sortable:true, tdClass: 'boldText'},
				{ key: "OriginalPrice", label: "Original Price", sortable:true},
				{ key: 'Price', label: 'Item Price', sortable: true, contenteditable: true},
				{ key: 'actions', label: 'Actions' }
					],
					searchedPlantFields: [
				{ key: "BatchId", label: "Batch Id"},
				{ key: "PlantName", label: "Plant Name", sortable: true },
				{ key: "FormSize", label: "Form Size" },
				{ key: "DateStamp", label: "Batch Upload" },
				{ key: "Location", label: "Location" },
				{ key: "BatchQuantity", label: "Saleable", sortable: true },
				{ key: "GrowingQuantity", label: "Growing", sortable: true },
				{ key: "AllocatedQuantity", label: "Allocated", sortable: true },
				{ key: "PurchasingPrice", label: "Purchasing Price"},
				{ key: "WholesalePrice", label: "Wholesale Price", sortable:true, tdClass: 'boldText'},
				{ key: "actions", label: "Actions" }
      		],
			isLoading: true,
			isLoading2: true,
			quoteDate: null,
			expiryDate: null,
			siteRef: null,
			quantity: null,
			comment: null,
			customerInfo: '',
			batches: [],
			selectedBatch: null,
			totalPrice: 0,
			quoteId: '',
			rowName: '',
			rowForm: '',
			rowComment: '',
			rowQuantity: '',
			rowPurchasingPrice: 0,
			rowWholesalePrice: 0,
			rowOriginalPrice: 0,
			rowPrice: '',
			rowActive: '',
			pricingValues: [
				{quantityMin: 1, quantityMax: 10, multiplier: 1},
				{quantityMin: 11, quantityMax: 20, multiplier: 0.9},
				{quantityMin: 21, quantityMax: 40, multiplier: 0.8},
				{quantityMin: 41, quantityMax: 60, multiplier: 0.75},
				{quantityMin: 61,quantityMax: 100, multiplier: 0.7},
			],
			calculatedPrice: '',
			nextCalculatedPrice: '',
			untilNextBand: '',
			showCollapse: true,
			showAddCollapse: false,
			currentGPM: '',
			retail: '',
			customPlantName: null,
			customFormSize: null,
			customComment: null,
			customQuantity: 0,
			customPrice: 0,
			showPlantPickerModal: false,
			currentSearchedPlants: [],
			originalSearchedPlants: [],
			plantSearch: '',
			showSearchTable: true,
			showAddingPlantSection: false, //Nice names lmao
			selectedRowFromSearch: null,
			plantNameFilters: [],
			formSizeFilters: [],
			locationFilters: [],
			selectedPlantNameFilter: null,
			selectedFormSizeFilter: null,
			selectedLocationFilter: null,
			showCalculatePrice: true,
			searchLatestBatches: true,
			totalQuantity: 0, 
			sellLessThanBuy: false,
			currentEditedPlant: null,
		}		
	},
  methods: {
		cancel() {
				this.$router.push('StockTable');
		},
		toCust() {
				this.$router.push('CustomerInformation');
		},
		remove(id) {
			this.plants.splice(id,1);
			this.getTotalPrice();
    },
    closeAddCollapse() {
      this.showAddCollapse = false;
    },
	// calculatePrice() {
	// 		if(this.selectedBatch != null) { //This method is called twice when using @input???
	// 			// this.calculatedPrice = ((this.selectedBatch.batchPrice/100)*0.9).toFixed(2);
	// 			// console.log("in calc price");
	// 			// console.log(this.selectedBatch.batchPrice);
	// 			// for (let i = 0; i < this.pricingValues.length; i++) {
	// 			// 	if(this.quantity >= this.pricingValues[i].quantityMin && this.quantity <= this.pricingValues[i].quantityMax) {
	// 			// 		this.calculatedPrice = ((this.selectedBatch.batchPrice/100)*this.pricingValues[i].multiplier).toFixed(2);
	// 			// 		this.nextCalculatedPrice = ((this.selectedBatch.batchPrice/100)*this.pricingValues[i + 1].multiplier).toFixed(2);
	// 			// 		this.untilNextBand = this.pricingValues[i + 1].quantityMin;
	// 			// 	} else if (this.quantity == 0){
	// 			// 		this.calculatedPrice = 0;
	// 			// 	} else if (this.quantity > this.pricingValues[i].quantityMax) {
	// 			// 		this.calculatedPrice = ((this.selectedBatch.batchPrice/100)*0.6).toFixed(2)
	// 			// 		this.nextCalculatedPrice = 0
	// 			// 		this.untilNextBand = 0
	// 			// 	}
	// 			// }
	// 			if(this.customerInfo.CustomerIsWholesale && this.customerInfo.SageCustomer == false) { //If a retail user has been selected use this price for the items on the quote
	// 				this.calculatedPrice = ((this.selectedBatch.batchPrice/100)*1.5).toFixed(2);
	// 			} else {
	// 				var ref = firebase.database().ref("GPM/").orderByKey();
	// 				let itemTotal = (this.selectedBatch.batchPrice/100)*this.quantity; //get the line total to work out what gpm to use
	// 				ref.on("value", (snapshot) => {
	// 					snapshot.forEach((child) => { //Loop through each of the different bands held within firebase
	// 							var obj = child.val();
	// 							if(itemTotal >= obj.rowMin && itemTotal <= obj.rowMax) { //If the itemTotal falls between these values a GPM value is used
	// 								this.currentGPM = ((1-obj.gpm)*100).toFixed(2);
	// 								//Apply the calculation to work out the price and add it onto the quote
	// 								this.calculatedPrice = ((this.selectedBatch.batchPrice/100)*obj.gpm).toFixed(2)
	// 							}
	// 						});
	// 				}, 
	// 				function (error) {
	// 					console.log("Error: " + error.code);
	// 				});
	// 			}
	// 		}
	// 	},
		searchArr(nameKey, myArray){
			 for (var i=0; i < myArray.length; i++) {
				if (myArray[i].name === nameKey) {
					return myArray[i];
    		}
			}
		},
		saveQuote() {
			//Do the min max check on all the prices on the quote to see if any of them change
			if (this.showCalculatePrice) {
				let calculatePricesObject = [];
				this.plants.forEach((x) => { 
					if (x.BatchId != 0) {
						calculatePricesObject.push({BatchId: parseInt(x.BatchId), PriceIn: x.Price.toString()});
					}
				});
				this.axios.post('https://ahillsquoteservice.azurewebsites.net/api/formpricing/list',
					calculatePricesObject
				) 
				.then((response) => {
					console.log("Prices returned from form pricing api");
					console.log("return data");
					console.log(response)
					console.log(this.plants)
					console.log("---------------------------------------")
					response.data.forEach(x => {
						
						//loop through response which will have the batchId and the prices
						for (var i=0; i < this.plants.length; i++) {
							//Loop though the plants that are on the quote and find the one that matches response
							if (this.plants[i].BatchId === x.BatchId && this.plants[i].Price == x.PriceIn) {
								console.log("------------------------------------------------")
								console.log(x);
								console.log("------------------------------------------------")
								//If the price is not the same after calculating it we need to update 
								if(x.PriceIn != x.PriceOut) {
									//Update the price as it will be different with the coming out from data
									this.plants[i].Price = x.PriceOut
									this.plants[i]._cellVariants = { Price: 'danger' }
								}
							}
    					}
					this.getTotalPrice();
					});
				})
				.catch((error) => {
					alert("Please check values before submitting")
					console.log(error);
				});
				this.showCalculatePrice = false;
			} else {
				this.axios.post('https://ahillsquoteservice.azurewebsites.net/api/quote', {
					CustomerRef: this.customerInfo.CustomerReference,
					TotalPrice: this.totalPrice,
					Date: this.quoteDate,
					ExpiryDate: this.expiryDate,
					SiteRef: this.siteRef,
					SalesOrder: 0,
					Retail: this.customerInfo.CustomerIsWholesale,
					Active: true,
					QuoteDetails: this.plants,
					VAT: 0,
				}) 
				.then((response) => {
					console.log(response);
					this.quoteId = response.data //Get the quoteId that is returned by the server to display on PDF
					this.$refs.createPDFModal.show()
				})
				.catch((error) => {
					alert("Please check values before submitting")
					console.log(error);
				});
			}
		},
	changeBatchSearchType() {
		this.searchLatestBatches = !this.searchLatestBatches;
	},
    validateBeforeSubmit(e) { //Check that all validation passes before adding
      if(this.showAddCollapse != true){
        this.$validator.validateAll();
        if (this.quantity != null && this.selectedBatch != null && this.quantity != null) { 
          this.addToList(); //If there are no validation errors and a batch has been selected add a plant to the list
        }
      } else {
        this.$validator.validate('customPlantName', this.customPlantName);
        this.$validator.validate('customFormSize', this.customFormSize);
        this.$validator.validate('customQuantity', this.customQuantity);
        this.$validator.validate('customPrice', this.customPrice);
        if(!this.errors.any()) {
          this.addToList();
        }
      }
	},
		validateEdits(e) { //Check that all validation passes before saving
      this.$validator.validate('rowQuantity', this.rowQuantity); //Validate the inputs on the modal
      this.$validator.validate('rowPrice', this.rowPrice);
      if (!this.errors.any()) { 
          this.saveEdits(); //If there are no validation errors and a batch has been selected add a plant to the list
      }
    },
		getTotalPrice() {
			this.totalPrice = 0; //Reset total price so correct quote price 
			this.totalQuantity = 0;
			this.plants.forEach((element) => { //Loop through the array of plants on quote
				let plantPrice = element.Quantity * element.Price; //Get the current price of that plant
				this.totalPrice += plantPrice; //Add it to the total cost of the quote
				this.totalQuantity += parseInt(element.Quantity);
			});
		},
		addToList(searchAgain) {
			if(this.showAddCollapse == true) {
				this.plants.push({
				BatchId: 0,
				PlantName: this.customPlantName,
				FormSize: this.customFormSize,
				Comment: this.customComment,
				Quantity: this.customQuantity,
				Price: this.customPrice,
				WholesalePrice: 0,
				PurchasingPrice: 0,
				OriginalPrice: 0,
				Active: true,
				});
						this.showAddCollapse = false;
						this.customPlantName = "";
						this.customFormSize = "";
						this.customComment = null;
						this.customQuantity = null;
						this.customPrice = null;
			}
			else {
				console.log(this.selectedRowFromSearch)
				this.plants.push({
				BatchId: this.selectedRowFromSearch.BatchId,
				PlantName: this.selectedRowFromSearch.PlantName,
				FormSize: this.selectedRowFromSearch.FormSize,
				Quantity: this.quantity,
				Comment: this.comment,
				Price: Math.trunc((this.calculatedPrice)*100), //Remove any trailing decimals so that it can be saved as an integer
				WholesalePrice: this.selectedRowFromSearch.WholesalePrice,
				PurchasingPrice: this.selectedRowFromSearch.PurchasingPrice,
				OriginalPrice: Math.trunc((this.calculatedPrice)*100),
				Active: true,
				_rowVariant: this.checkIfBatchHasPrice(this.selectedRowFromSearch.WholesalePrice), //Pass to method
					});
			}
			
			this.getTotalPrice(); //Once a plant is added recalculate the current quote price
			//Reset input and validation
			this.$validator.reset();
			if (searchAgain)
			{
				this.searchAgain();
			} else {
				this.backToLastSearch();
			}
			
		},
		editItem(row, rowId) {
			this.currentEditedPlant = null; //Reset the value
			this.currentEditedPlant = row;
			console.log(rowId)
			this.$refs['editModal'+rowId].show(); //Open editing modal
			console.log(row)
			this.currentRowId = rowId; //Set the current values of the row so they can be edited then spliced into array
			this.rowPlantForQuoteId = row.PlantForQuoteId;
			this.rowName = row.PlantName;
			this.rowForm = row.FormSize
			this.rowComment = row.Comment;
			this.rowQuantity = row.Quantity;
			this.rowPurchasingPrice = row.PurchasingPrice,
			this.rowOriginalPrice = row.OriginalPrice,
			this.rowWholesalePrice = row.WholesalePrice,
			this.rowPrice = (row.Price/100).toFixed(2); 
			this.rowActive = row.Active;
		},
		saveEdits() {
			console.log(this.currentEditedPlant);
			console.log(this.rowComment)
			this.currentEditedPlant.Comment = this.rowComment;
			this.currentEditedPlant.Quantity = this.rowQuantity;
			this.currentEditedPlant.Price = this.rowPrice*100;
		// 	this.plants.splice(this.currentRowId, 1,{ //Replace current row with new values inputted by splicing new object into
		// 	PlantName: this.rowName,                  //its current postion
		// 	FormSize: this.rowForm,
		// 	Comment: this.rowComment,
		// 	Quantity: parseInt(this.rowQuantity),
		// 	Price:  parseFloat(this.rowPrice)*100, //Parsing edited value eg: "1.55" = 155 so it can be saved to db
		// 	WholesalePrice: this.rowWholesalePrice,
		// 	PurchasingPrice: this.rowPurchasingPrice,
		// 	OriginalPrice: this.rowOriginalPrice,
		// 	Active: this.rowActive,
		// 	_rowVariant: '',
      	// });
		this.getTotalPrice();
		this.hideModal(this.currentRowId);
		this.$validator.reset();
    	},
		hideModal(rowId) {
			this.$refs['editModal'+rowId].hide();
		},
		checkIfBatchHasPrice(price) { //This method will determine if the batch has a price or not
			if(price <= 0) {
				return 'danger' //If it doesnt change the _rowVariant which will then highlight the row red
			} else {
				return '' //Else it has a price so dont highlight the row
			}
		},
		openPlantPickerModal()
		{
			this.showPlantPickerModal = true;
			this.showAddCollapse = false;
			this.currentSearchedPlants = [];
			this.originalSearchedPlants = [];
			this.plantSearch = "";
			this.formSizeFilters = [];
			this.plantNameFilters = [];
			this.locationFilters = [];
			this.selectedPlantNameFilter = null;
			this.selectedFormSizeFilter = null;
			this.selectedLocationFilter = null;
			this.showCalculatePrice = true;
		},
		searchAgain()
		{
			this.currentSearchedPlants = [];
			this.originalSearchedPlants = [];
			this.plantSearch = ""
			this.selectedRowFromSearch = null;
			this.showAddingPlantSection = false;
			this.showSearchTable = true;
			this.currentGPM = '';
			this.quantity = null
			this.comment = null
			this.calculatedPrice = '';
			this.selectedPlantNameFilter = null;
			this.selectedFormSizeFilter = null;
			this.selectedLocationFilter = null;
			this.formSizeFilters = [];
			this.plantNameFilters = [];
			this.locationFilters = [];
		},
		backToLastSearch()
		{
			this.selectedRowFromSearch = null;
			this.showAddingPlantSection = false;
			this.showSearchTable = true;
			this.currentGPM = '';
			this.quantity = null
			this.comment = null
      		this.calculatedPrice = '';
		},
		clearSearch()
    	{
			this.currentSearchedPlants = [];
			this.originalSearchedPlants = [];
			this.plantSearch = ""
			this.selectedRowFromSearch = null;
			this.selectedPlantNameFilter = null;
			this.selectedFormSizeFilter = null;
			this.selectedLocationFilter = null;
			this.formSizeFilters = [];
			this.plantNameFilters = [];
			this.locationFilters = [];
		},
		showModalOtherScreen(row)
		{
			this.showAddingPlantSection = true;
			this.showSearchTable = false;
			this.selectedRowFromSearch = row;
		},
		filterCurrentSearchedPlants()
		{
			if (this.selectedPlantNameFilter != null)
			{
				let selectedPlants = this.currentSearchedPlants.filter(x => //Loop through batches to find which match the one selected for picking
					(x.PlantName === this.selectedPlantNameFilter));
				this.currentSearchedPlants = selectedPlants;
			}
			if (this.selectedFormSizeFilter != null)
			{
				let selectedPlants = this.currentSearchedPlants.filter(x => //Loop through batches to find which match the one selected for picking
					(x.FormSize.toLowerCase().includes(this.selectedFormSizeFilter.toLowerCase())));
					
				this.currentSearchedPlants = selectedPlants;
			}
			if (this.selectedLocationFilter != null)
			{
				let selectedPlants = this.currentSearchedPlants.filter(x => //Loop through batches to find which match the one selected for picking
				(x.Location === this.selectedLocationFilter));
				this.currentSearchedPlants = selectedPlants;
			}
		},
		clearFilterCurrentSearchedPlants()
		{
			this.selectedPlantNameFilter = null;
			this.selectedFormSizeFilter = null;
			this.selectedLocationFilter = null;
			this.currentSearchedPlants = this.originalSearchedPlants;
		},
		removePBFromCurrentSearchedPlants()
		{
			let selectedPlants = this.currentSearchedPlants.filter(x => //Loop through batches to find which match the one selected for picking
				(x.Location != "PB"));
				this.currentSearchedPlants = selectedPlants;
		},
		searchForPlant()
    	{
		console.log(this.plantSearch);
        this.axios.get("https://ahillsbatchservice.azurewebsites.net/api/search?searchQuery="+this.plantSearch+"&searchCurrentBatches="+this.searchLatestBatches
        )
        .then(response => {
					var tempPNF = [];
					var tempFSF = [];
					var tempLF = [];
					this.currentSearchedPlants = [];
          for (var i = 0; i < response.data.length; i++) {
            this.currentSearchedPlants.push({
              BatchId: response.data[i].BatchId,
              PlantName: response.data[i].Name,
              FormSize: response.data[i].FormSize,
              Location: response.data[i].Location,
              BatchQuantity: response.data[i].Quantity,
              GrowingQuantity: response.data[i].GrowingQuantity,
              AllocatedQuantity: response.data[i].AllocatedQuantity,
              WholesalePrice: response.data[i].WholesalePrice,
			  DateStamp: response.data[i].DateStamp.split('T')[0],
			  PurchasingPrice: response.data[i].PurchasingPrice,
						});
						
						tempPNF.push(response.data[i].Name);
						tempFSF.push(response.data[i].FormSize);
						tempLF.push(response.data[i].Location);
					}
					this.selectedPlantNameFilter = null;
					this.selectedFormSizeFilter = null;
					this.selectedLocationFilter = null;
					this.originalSearchedPlants = this.currentSearchedPlants;
					this.plantNameFilters = this.removeDuplicates(tempPNF);
					this.formSizeFilters = this.removeDuplicates(tempFSF);
					this.locationFilters = this.removeDuplicates(tempLF);
					this.isLoading = false;
				})
        .catch(error => {
          alert(error);
		});
				
		},
		//I really cba doing anything fancy with this so have a copy and paste
		searchForPlantEnter(event) {
			if (event.which === 13) {
				this.axios.get("https://ahillsbatchservice.azurewebsites.net/api/search?searchQuery="+this.plantSearch+"&searchCurrentBatches="+this.searchLatestBatches
				)
				.then(response => {
							var tempPNF = [];
							var tempFSF = [];
							var tempLF = [];
							this.currentSearchedPlants = [];
				for (var i = 0; i < response.data.length; i++) {
					this.currentSearchedPlants.push({
					BatchId: response.data[i].BatchId,
					PlantName: response.data[i].Name,
					FormSize: response.data[i].FormSize,
					Location: response.data[i].Location,
					BatchQuantity: response.data[i].Quantity,
					GrowingQuantity: response.data[i].GrowingQuantity,
					AllocatedQuantity: response.data[i].AllocatedQuantity,
					WholesalePrice: response.data[i].WholesalePrice,
					DateStamp: response.data[i].DateStamp.split('T')[0],
					PurchasingPrice: response.data[i].PurchasingPrice,
								});
								
								tempPNF.push(response.data[i].Name);
								tempFSF.push(response.data[i].FormSize);
								tempLF.push(response.data[i].Location);
							}
							this.selectedPlantNameFilter = null;
							this.selectedFormSizeFilter = null;
							this.selectedLocationFilter = null;
							this.originalSearchedPlants = this.currentSearchedPlants;
							this.plantNameFilters = this.removeDuplicates(tempPNF);
							this.formSizeFilters = this.removeDuplicates(tempFSF);
							this.locationFilters = this.removeDuplicates(tempLF);
							this.isLoading = false;
						})
				.catch(error => {
				alert(error);
				});
			}
		},
		removeDuplicates(array) {
			console.log(array);
				return array.filter((a, b) => array.indexOf(a) === b)
		},
		calculatePriceNew() {
				//--------------------------------------------------------------------------------------------------------------------------------------------------------------------
				//Going to try deal with this fucking god afwul function that works of the price by communicating to firebase? Need to just put these into the database.
				//Then you can just called them on page load and save them into session storage because fuck using this 
				//---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
				let itemTotal = (this.selectedRowFromSearch.WholesalePrice/100)*this.quantity; //get the line total to work out what gpm to use
				console.log(this.selectedRowFromSearch);
				if (this.selectedRowFromSearch.WholesalePrice == this.selectedRowFromSearch.PurchasingPrice || this.selectedRowFromSearch.WholesalePrice < this.selectedRowFromSearch.PurchasingPrice) {
					this.sellLessThanBuy = true;
				} else {
					this.sellLessThanBuy = false;
				}
				if(this.customerInfo.CustomerIsWholesale && this.customerInfo.SageCustomer == false) { //If a retail user has been selected use this price for the items on the quote
					this.calculatedPrice = ((this.selectedRowFromSearch.WholesalePrice/100)*1.5).toFixed(2); //RETAIL CUSTOMER HAS A SET PRICE -- NEED TO HAVE THIS SOMEWHERE TOO
				} else {
					if (this.selectedRowFromSearch.WholesalePrice/100 > 60) //Use the upper GPM bands
					{
						var ref = firebase.database().ref("GPM2/").orderByKey();
						
						ref.on("value", (snapshot) => {
							snapshot.forEach((child) => { //Loop through each of the different bands held within firebase
									var obj = child.val();
									if(itemTotal >= obj.rowMin && itemTotal <= obj.rowMax) { //If the itemTotal falls between these values a GPM value is used
										this.currentGPM = ((1-obj.gpm)*100).toFixed(2);
										//Apply the calculation to work out the price and add it onto the quote
										this.calculatedPrice = ((this.selectedRowFromSearch.WholesalePrice/100)*obj.gpm).toFixed(2)
									}
								});
						}, 
						function (error) {
							console.log("Error: " + error.code);
						});	
					} else {
						var ref = firebase.database().ref("GPM/").orderByKey();
						
						ref.on("value", (snapshot) => {
							snapshot.forEach((child) => { //Loop through each of the different bands held within firebase
									var obj = child.val();
									if(itemTotal >= obj.rowMin && itemTotal <= obj.rowMax) { //If the itemTotal falls between these values a GPM value is used
										this.currentGPM = ((1-obj.gpm)*100).toFixed(2);
										//Apply the calculation to work out the price and add it onto the quote
										this.calculatedPrice = ((this.selectedRowFromSearch.WholesalePrice/100)*obj.gpm).toFixed(2)
									}
								});
						}, 
						function (error) {
							console.log("Error: " + error.code);
						});	
					}
				}
		},
		getBatchList() {
			// if(sessionStorage.getItem('batchList') != null) {
			// 	let batchList = sessionStorage.getItem('batchList');
			// 	this.batches = JSON.parse(batchList);
			// 	this.isLoading = false;
			// } else {
			// 	if(confirm("Please go back to stock table to load batches")) {
			// 			this.$router.push('StockTable');
			// 		}
			// }
		},
		getFirebase() {
			var ref = firebase.database().ref("GPM/").orderByKey();
			// console.log(ref);
			ref.on("value", (snapshot) => {
          snapshot.forEach((child) => { 
							var obj = child.val();
							if(child.key == "VAT"){
								this.VAT = obj.value;
								// console.log(this.VAT);
							}
            });
			}, 
			function (error) {
        console.log("Error: " + error.code);
      });
		},
		formatPriceForPDF() {
      //This is done after the quote has been saved to the database so changes will only show on created PDF
      //Map through the list of plants changing the price from "250p to 2.50"
      this.plants.map(o => Object.assign(o, {Price: "£"+(o.Price/100).toFixed(2)}))
    },
	sortPlantsIntoOrder() {
		this.plants.sort((a,b) => (a.PlantName > b.PlantName) ? 1 : ((b.PlantName > a.PlantName) ? -1 : 0))
	},
		createPDF () {
			let totalInt = 0;
			this.plants.forEach(element => {
				element.lineVat = "£"+((element.Price/10000)*20).toFixed(2);
			totalInt = totalInt + parseInt(element.Quantity);
			});
			this.formatPriceForPDF();
			this.sortPlantsIntoOrder();
			let pdfName = this.quoteId + "-" + this.customerInfo.CustomerName + "-" + this.quoteDate; 
			var columns = [
				{title: "Quantity", dataKey: "Quantity"},
				{title: "Plant Name", dataKey: "PlantName"},
				{title: "Form Size", dataKey: "FormSize"},
				{title: "Comment", dataKey: "Comment"},
				{title: "Price", dataKey: "Price"},
				{title: "VAT", dataKey: "lineVat"},
			];
			var companyLogo = {
				src: 'data:image/png;base64,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'
			}
			var companyInfo = "Station Nurserys\n" +
												"Stokesley\n" +
												"Middlesbrough\n" +
												"TS9 7AB\n" +
												"Tel: 01642 711281\n" +
												"Email: enquiries@hillandsons.co.uk\n" +
												"Web: hillandsons.co.uk\n" +
												"Stock: hillsstock.co.uk"
			var quoteInfo =	"Quote Id: " + this.quoteId + "\n" +
												 "Customer Ref: " + this.customerInfo.CustomerReference + "\n" +
											     "Start Date: " + this.quoteDate + "\n" 
			var deliveryInfo = 					 "Name: " + this.customerInfo.CustomerName + "\n" +
												 "Ref: " + this.customerInfo.CustomerReference + "\n" +
												 "Tel: " + this.customerInfo.CustomerTel + "\n" +
												 "Email: " + this.customerInfo.CustomerEmail + "\n" +
												 "Address: "+ this.customerInfo.CustomerAddress + "\n"
			var doc = new jsPDF('p', 'pt');
			doc.addImage(companyLogo.src, 'PNG', 30, 30, 100, 75);
			doc.setFontSize(20);
			doc.text("Quotation", 443, 35)
			doc.setFontSize(10);
			doc.text(companyInfo, 135, 35);
			doc.text(quoteInfo, 443, 50);
			if (this.siteRef == null) {
				this.siteRef = "";
			}
			doc.text("Site Reference: " + this.siteRef, 400, 140);
			doc.setFontSize(12);
      	doc.text("Expiry Date: " + this.expiryDate, 400, 155)
			doc.setLineWidth(1);
			doc.line(0,125,700,125) 
			doc.setFontSize(10);
			doc.text(deliveryInfo, 40, 140)
			doc.autoTable(columns, this.plants, {theme: 'striped', startY: 200, 
																						styles: {
																							overflow: 'linebreak',
																							cellWidth: 'auto',
																							},
																					});
			let finalY = doc.autoTable.previous.finalY;
			let quotePrice = (this.totalPrice/100).toFixed(2);
			let quoteVAT = (quotePrice/100*20).toFixed(2);
			let priceAfterVAT = (parseFloat(quotePrice)+parseFloat(quoteVAT)).toFixed(2);
			let footerText = "These Prices Exclude Delivery Charges Unless Quoted";			
			let totalText = "Total: " + totalInt;
			doc.text(totalText,40, finalY+15);
			doc.setFontSize(12);
			doc.text(footerText,140, finalY+15);
      doc.setLineWidth(1);
      doc.line(140,finalY+17,435,finalY+17) 
			doc.text("Total Exc. VAT: £" + quotePrice, 380, finalY+40);
			doc.text("VAT:                  £" + quoteVAT, 380, finalY+55);
      doc.text("Total Inc. VAT:  £" + priceAfterVAT, 380, finalY+70);
      
      doc.setFontSize(10);
      doc.text("Thank you for your Enquiry",120,finalY+40)
      doc.setFontSize(8);
      doc.text("We look forward to our next opportunity to price for you", 90, finalY+50);
      doc.text("Vat No 258 1678 29 : Plant Passport No GB/12803 : Company No 4395902", 60, finalY+60);
      doc.text("Directors D.Hill : M.Hill : J.Hill : S.Hill", 120, finalY+70);
			doc.save(pdfName + '.pdf');

			this.$router.push('ExistingQuotes');
  	},
		getQuoteDate() {
			this.quoteDate = moment(new Date).format('DD/MM/YYYY');
			this.expiryDate = moment(new Date).add('30', 'days').format('DD/MM/YYYY')
		},
		getPrice (price) { //Does the same as computed method but passed in a value
      return (price/100).toFixed(2);
		},
		getSelectedCustomerFromStorage()
		{
			this.customerInfo = JSON.parse(localStorage.getItem('selectedCustomer'));
			 
		}
	},
	computed: {
    computedTotalPrice () { ///Whenever total value is shown this will format to look monitary
      return (this.totalPrice/100).toFixed(2);
		},
	},
	mounted() {
		this.getBatchList();
		this.getQuoteDate();
		this.getFirebase();
		this.showCalculatePrice = true;
	},
	created() {
		window.onbeforeunload = function() {
			return 'This wont save the quote?';
		};
		this.getSelectedCustomerFromStorage();
		// window.onpopstate = function() {
		// 	confirm("Warning changes havent been saved. Go back to customer selection?");
			
		// }
		// if(this.$route.params.custFromList) { //If singleCustomer is null then a customer from dropdown has been passed through
		// 	this.customerInfo = this.$route.params.selectedCustomer;
		// } else {
		// 	this.customerInfo = this.$route.params.singleCustomer;
		// 	// if(this.$route.params.retail) { //When manually entered customer is used, choose the referenced based on if trade or retail is chosen
		// 	// 	this.customerInfo.customerRef = this.$route.params.retCustomer;
		// 	// } else {
		// 	// 	this.customerInfo.customerRef = this.$route.params.trdCustomer;
		// 	// }
		// }
		// this.siteRef = this.$route.params.siteRef;
		// this.retail = this.$route.params.retail;
	},
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
@import "https://cdn.jsdelivr.net/npm/animate.css@3.5.1";
/* @import "https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css";  */
@import "https://use.fontawesome.com/releases/v5.7.2/css/all.css";
@import "../../../css/main.css";
	.section {
    width: 100%;
		height: 500px;
    background: aqua;
	}

	.left-div
	{
    width: 30%;
		height: 100%; 
		float:left;
	}

	.right-div {
		float:left;
		width:70%;
		overflow:hidden;
	}
	
	/* starts here */
	  ul {
    margin: 0;
    padding: 0;
    list-style-type: none;
  }
  
  p {
    text-align:center;
		margin: 0px;
  }

  .boldText {
		font-style: italic;
		font-weight: bold;
	}

  .container {
    box-shadow: 0px 0px 40px lightgray;
  }

  input {
  	border: 1px solid #e8e8e8;
		font-size: 16px;
		min-height: 40px;
  }

	.custom-icon {
		margin-top: 3px;	
		cursor:pointer;
		margin-left: 10px;
	}

	/* Ends here */
	.multiselect {
		margin-bottom: 10px;
	}

	.navbar-custom {
			background-color: #15c015;
	}

	.modal-lg {
		max-width: auto !important;
		width: 2000px !important;
	}



	@media only screen and (max-width : 768px) {

	.left-div {
		position: relative;
		width: 100%;
	}

	.right-div {
		width: 100%;
		position: relative;
		/* visibility: hidden; */
	}

	.info-div {
		width: 100%;
		position: relative; 
		top:0;
	}

	#flex { display: flex; flex-direction: column; }
	#left { order: 2; }
	#info { order: 1; }
	#right { order: 3; } 

	}

	

	/* Make the height fit on mobile, just make sure that it fits on any screen smaller than 768 */
</style>



// WEBPACK FOOTER //
// src/views/QuotingSystem/QuoteCreation.vue